/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Represents a DataLeaks risk summary object for a given domain.
 * @export
 * @interface CRSFDataleaksRiskSummaryObject
 */
export interface CRSFDataleaksRiskSummaryObject {
    /**
     * 
     * @type {number}
     * @memberof CRSFDataleaksRiskSummaryObject
     */
    all_severity_20: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFDataleaksRiskSummaryObject
     */
    all_severity_25: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFDataleaksRiskSummaryObject
     */
    all_severity_5: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFDataleaksRiskSummaryObject
     */
    hits: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFDataleaksRiskSummaryObject
     */
    matched_severity_20: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFDataleaksRiskSummaryObject
     */
    matched_severity_25: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFDataleaksRiskSummaryObject
     */
    matched_severity_5: number;
}

/**
 * Check if a given object implements the CRSFDataleaksRiskSummaryObject interface.
 */
export function instanceOfCRSFDataleaksRiskSummaryObject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "all_severity_20" in value;
    isInstance = isInstance && "all_severity_25" in value;
    isInstance = isInstance && "all_severity_5" in value;
    isInstance = isInstance && "hits" in value;
    isInstance = isInstance && "matched_severity_20" in value;
    isInstance = isInstance && "matched_severity_25" in value;
    isInstance = isInstance && "matched_severity_5" in value;

    return isInstance;
}

export function CRSFDataleaksRiskSummaryObjectFromJSON(json: any): CRSFDataleaksRiskSummaryObject {
    return CRSFDataleaksRiskSummaryObjectFromJSONTyped(json, false);
}

export function CRSFDataleaksRiskSummaryObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDataleaksRiskSummaryObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'all_severity_20': json['all_severity_20'],
        'all_severity_25': json['all_severity_25'],
        'all_severity_5': json['all_severity_5'],
        'hits': json['hits'],
        'matched_severity_20': json['matched_severity_20'],
        'matched_severity_25': json['matched_severity_25'],
        'matched_severity_5': json['matched_severity_5'],
    };
}

export function CRSFDataleaksRiskSummaryObjectToJSON(value?: CRSFDataleaksRiskSummaryObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'all_severity_20': value.all_severity_20,
        'all_severity_25': value.all_severity_25,
        'all_severity_5': value.all_severity_5,
        'hits': value.hits,
        'matched_severity_20': value.matched_severity_20,
        'matched_severity_25': value.matched_severity_25,
        'matched_severity_5': value.matched_severity_5,
    };
}

